import React from 'react';
import './App.css';
import Navbar from './components/Navbar/Navbar';
import HeroSection from './components/HeroSection/HeroSection';
import FeaturesSection from './components/FeaturesSection/FeaturesSection';
import FloatingButtons from './components/FloatingButtons/FloatingButtons';
import Footer from './components/Footer/Footer';
import AboutUs from './components/AboutUs/AboutUs';
import Counselling from './components/Counselling/Counselling';
import Gallery from './components/Gallery/Gallery';
import Contact from './components/Enquiry/Contact';

function App() {
  return (
    <div className="App">
      <Navbar />
      <HeroSection />
      <FeaturesSection />
      <AboutUs />
      <Counselling />
      <Gallery />
      <Contact />
      <FloatingButtons />
      <Footer />

    </div>
  );
}

export default App;
